import { NgFor } from '@angular/common';
import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { StoryblokRichTextDirective } from 'src/app/directive/storyblok-richtext.directive';
import { EnvironmentService } from 'src/app/service/environment.service';

@Component({
    selector: 'app-reviews',
    imports: [NgFor, StoryblokRichTextDirective],
    templateUrl: './reviews.component.html',
    styleUrl: './reviews.component.scss'
})
export class ReviewsComponent implements OnChanges {
  @Input() _editable: any;
  @Input() _uid!: string;
  @Input() component!: string;
  @Input() reviews: any;
  @ViewChild('container') private container!: ElementRef;
  @ViewChild('reviewscontainer') private reviewscontainer!: ElementRef;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private environmentService: EnvironmentService
  ) {}

  ngOnChanges(): void {
    this.reviews = [...this.reviews, ...this.reviews];
    setTimeout(() => {
      if (this.environmentService.isBrowser()) {
        this.renderer.setProperty(
          this.reviewscontainer.nativeElement,
          'scrollLeft',

          parseInt(
            this.environmentService
              .getWindow()!
              .getComputedStyle(this.container.nativeElement)
              .marginLeft.split('px')[0]
          )
        );
      }
    }, 50);
  }
}
